

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseCRUDService } from '../../services/base-crud.service';
import { Country } from './country.model';

@Injectable({
    providedIn: 'root'
})
export class CountryService extends BaseCRUDService<Country> {

    constructor(http: HttpClient) {
        super(http, 'country');
    }
}
